import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export type DialogSourceProps = ComponentProps<'div'>

export const DialogSource = (props: DialogSourceProps) => {
  const {children, className, ...restProps} = props
  return (
    <div
      className={twMerge('text-p1 text-glyph-default-secondary', className)}
      {...restProps}
    >
      {children}
    </div>
  )
}
